var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "app-container",
      attrs: { "element-loading-text": "加载中..." },
    },
    [
      _c(
        "el-card",
        {
          staticClass: "sticky-container",
          attrs: { shadow: "never", "body-style": { padding: "0 0 20px" } },
        },
        [
          _c(
            "template",
            { slot: "header" },
            [
              _c(
                "el-row",
                { staticClass: "filter-container", attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 6 } },
                    [
                      _c("el-input", {
                        staticClass: "filter-item",
                        attrs: { placeholder: "供应商名称", clearable: "" },
                        model: {
                          value: _vm.queryParams.keyword,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "keyword", $$v)
                          },
                          expression: "queryParams.keyword",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 3 } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "filter-item",
                          attrs: { placeholder: "状态", clearable: "" },
                          model: {
                            value: _vm.queryParams.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "status", $$v)
                            },
                            expression: "queryParams.status",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "禁用", value: 0 },
                          }),
                          _c("el-option", {
                            attrs: { label: "启用", value: 1 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 9 } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: { type: "primary", icon: "el-icon-search" },
                          on: { click: _vm.handleFilter },
                        },
                        [_vm._v("查找")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          staticStyle: { "margin-left": "10px" },
                          attrs: { type: "danger", icon: "el-icon-edit" },
                          on: { click: _vm.handleCreate },
                        },
                        [_vm._v("增加供应商")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                { name: "sticky-header", rawName: "v-sticky-header" },
              ],
              attrs: {
                fit: "",
                "highlight-current-row": "",
                data: _vm.list,
                "header-cell-class-name": "table-header-cell style1",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  width: "60",
                  align: "center",
                  type: "index",
                  "class-name": "table-header-cell style1",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "供应商名称",
                  prop: "supplierName",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "联系人", prop: "contact", width: "150" },
              }),
              _c("el-table-column", {
                attrs: { label: "联系电话", prop: "mobile", width: "150" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "发货地址",
                  prop: "shippingAddress",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "退货地址",
                  prop: "deliveryAddress",
                  "min-width": "150",
                },
              }),
              _c(
                "el-table-column",
                {
                  attrs: { label: "状态", width: "80", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("el-switch", {
                            staticClass: "rectangle md",
                            attrs: { "active-value": 1, "inactive-value": 0 },
                            on: {
                              change: function ($event) {
                                return _vm.handleUpdate(row)
                              },
                            },
                            model: {
                              value: row.status,
                              callback: function ($$v) {
                                _vm.$set(row, "status", $$v)
                              },
                              expression: "row.status",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                },
                [_vm._v('" ')]
              ),
              _c("el-table-column", {
                attrs: { align: "center", width: "80", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-dropdown",
                          { attrs: { trigger: "click" } },
                          [
                            _c("span", { staticClass: "el-dropdown-link" }, [
                              _vm._v(" 操作"),
                              _c("i", {
                                staticClass:
                                  "el-icon-arrow-down el-icon--right",
                              }),
                            ]),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "el-dropdown-item",
                                  {
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleEdit(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-edit" }),
                                    _vm._v(" 编辑供应商"),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleRemove(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-delete" }),
                                    _vm._v(" 删除供应商"),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: { divided: "" },
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleReset(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-refresh" }),
                                    _vm._v(" 重置密码"),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("pagination", {
            attrs: {
              total: _vm.total,
              page: _vm.queryParams.page,
              limit: _vm.queryParams.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.queryParams, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.queryParams, "limit", $event)
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogFormTitle,
            visible: _vm.dialogFormVisible,
            fullscreen: _vm.device === "mobile",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              staticStyle: { "padding-right": "15px" },
              attrs: {
                rules: _vm.rules,
                model: _vm.detail,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "供应商名称", prop: "supplierName" },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入供应商名称",
                              clearable: "",
                            },
                            model: {
                              value: _vm.detail.supplierName,
                              callback: function ($$v) {
                                _vm.$set(_vm.detail, "supplierName", $$v)
                              },
                              expression: "detail.supplierName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    {
                      attrs: { xs: 24, sm: 12, lg: _vm.showPassword ? 8 : 12 },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "inline-form-item",
                          attrs: { label: "联系人", prop: "contact" },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入联系人名称",
                              clearable: "",
                            },
                            model: {
                              value: _vm.detail.contact,
                              callback: function ($$v) {
                                _vm.$set(_vm.detail, "contact", $$v)
                              },
                              expression: "detail.contact",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    {
                      attrs: { xs: 24, sm: 12, lg: _vm.showPassword ? 8 : 12 },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "inline-form-item",
                          attrs: { label: "联系电话", prop: "mobile" },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入联系电话",
                              maxlength: "11",
                              clearable: "",
                            },
                            model: {
                              value: _vm.detail.mobile,
                              callback: function ($$v) {
                                _vm.$set(_vm.detail, "mobile", $$v)
                              },
                              expression: "detail.mobile",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.showPassword
                    ? _c(
                        "el-col",
                        { attrs: { xs: 24, sm: 12, lg: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "inline-form-item",
                              attrs: { label: "登录密码", prop: "password" },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入登录密码",
                                  "show-password": "",
                                },
                                model: {
                                  value: _vm.detail.password,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detail, "password", $$v)
                                  },
                                  expression: "detail.password",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "发货地址", prop: "shippingAddress" },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入发货地址",
                              clearable: "",
                            },
                            model: {
                              value: _vm.detail.shippingAddress,
                              callback: function ($$v) {
                                _vm.$set(_vm.detail, "shippingAddress", $$v)
                              },
                              expression: "detail.shippingAddress",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "退货地址", prop: "deliveryAddress" },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                placeholder: "请输入退货地址",
                                clearable: "",
                              },
                              model: {
                                value: _vm.detail.deliveryAddress,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detail, "deliveryAddress", $$v)
                                },
                                expression: "detail.deliveryAddress",
                              },
                            },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: { slot: "append" },
                                  on: { change: _vm.sameAddress },
                                  slot: "append",
                                },
                                [_vm._v("同发货地址")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, md: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "营业执照代码", prop: "licenceNo" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入营业执照统一社会信用代码",
                              clearable: "",
                            },
                            model: {
                              value: _vm.detail.licenceNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.detail, "licenceNo", $$v)
                              },
                              expression: "detail.licenceNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, md: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "资质编号", prop: "qualification" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入资质编号",
                              clearable: "",
                            },
                            model: {
                              value: _vm.detail.qualification,
                              callback: function ($$v) {
                                _vm.$set(_vm.detail, "qualification", $$v)
                              },
                              expression: "detail.qualification",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, md: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "营业执照", prop: "businessLicense" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "image-uploader" },
                            [
                              _c(
                                "el-upload",
                                {
                                  staticClass: "avatar-uploader",
                                  attrs: {
                                    action: "#",
                                    accept: "image/*",
                                    "show-file-list": false,
                                    "on-change": _vm.imageChange.bind(null, {
                                      key: "businessLicense",
                                    }),
                                    "http-request": _vm.imageUpload.bind(null, {
                                      key: "businessLicense",
                                    }),
                                  },
                                },
                                [
                                  _vm.licenseImage.url
                                    ? [
                                        _c("img", {
                                          staticClass: "avatar",
                                          attrs: { src: _vm.licenseImage.url },
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "el-upload-img-actions",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-upload-img-preview",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.imagePreview({
                                                      key: "businessLicense",
                                                    })
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-zoom-in",
                                                }),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-upload-img-delete",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.imageBeforeRemove(
                                                      { key: "businessLicense" }
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-delete",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _c("i", {
                                        staticClass:
                                          "el-icon-plus avatar-uploader-icon",
                                      }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, md: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "资质图片",
                            prop: "certificatePhoto",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "image-uploader" },
                            [
                              _c(
                                "el-upload",
                                {
                                  staticClass: "avatar-uploader",
                                  attrs: {
                                    action: "#",
                                    accept: "image/*",
                                    "show-file-list": false,
                                    "on-change": _vm.imageChange.bind(null, {
                                      key: "certificatePhoto",
                                    }),
                                    "http-request": _vm.imageUpload.bind(null, {
                                      key: "certificatePhoto",
                                    }),
                                  },
                                },
                                [
                                  _vm.qualificationImage.url
                                    ? [
                                        _c("img", {
                                          staticClass: "avatar",
                                          attrs: {
                                            src: _vm.qualificationImage.url,
                                          },
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "el-upload-img-actions",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-upload-img-preview",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.imagePreview({
                                                      key: "certificatePhoto",
                                                    })
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-zoom-in",
                                                }),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-upload-img-delete",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.imageBeforeRemove(
                                                      {
                                                        key: "certificatePhoto",
                                                      }
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-delete",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _c("i", {
                                        staticClass:
                                          "el-icon-plus avatar-uploader-icon",
                                      }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "inline-form-item",
                          attrs: { label: "启用" },
                        },
                        [
                          _c("el-switch", {
                            staticClass: "rectangle",
                            attrs: {
                              width: 60,
                              "active-value": 1,
                              "inactive-value": 0,
                            },
                            model: {
                              value: _vm.detail.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.detail, "status", $$v)
                              },
                              expression: "detail.status",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "medium" },
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("取  消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "medium", type: "primary" },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("提交保存")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("el-image", {
        ref: "elImage",
        staticStyle: { width: "0", height: "0" },
        attrs: { src: _vm.previewImg, "preview-src-list": _vm.previewList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }